var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_6829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.48969 10.1096C2.4496 9.7778 2.42956 9.44386 2.42969 9.10962C2.42765 7.36187 3.03525 5.66813 4.14781 4.32023C5.26036 2.97232 6.80821 2.05466 8.52465 1.72535C10.2411 1.39604 12.0187 1.6757 13.5511 2.51615C15.0835 3.3566 16.2748 4.70521 16.9197 6.32962",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 14.42L17.42 16.59",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 20.19C23.1473 20.3273 23.2655 20.4929 23.3475 20.6769C23.4294 20.8609 23.4735 21.0596 23.4771 21.261C23.4806 21.4624 23.4436 21.6624 23.3681 21.8492C23.2927 22.036 23.1804 22.2056 23.038 22.3481C22.8955 22.4905 22.7259 22.6028 22.5391 22.6782C22.3523 22.7537 22.1523 22.7907 21.9509 22.7872C21.7494 22.7836 21.5508 22.7395 21.3668 22.6576C21.1828 22.5756 21.0172 22.4574 20.8799 22.31L16.9999 18.42C16.9062 18.327 16.8318 18.2164 16.781 18.0946C16.7302 17.9727 16.7041 17.842 16.7041 17.71C16.7041 17.578 16.7302 17.4473 16.781 17.3254C16.8318 17.2036 16.9062 17.093 16.9999 17L17.7099 16.29C17.8029 16.1963 17.9135 16.1219 18.0353 16.0711C18.1572 16.0203 18.2879 15.9942 18.4199 15.9942C18.5519 15.9942 18.6826 16.0203 18.8045 16.0711C18.9263 16.1219 19.0369 16.1963 19.1299 16.29L22.9999 20.19Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0098 1.25H22.0098V5.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.44 9.55957C17.3415 11.2133 16.6991 12.788 15.6126 14.0387C14.5262 15.2893 13.0567 16.1456 11.433 16.4742C9.80925 16.8028 8.12244 16.5853 6.63518 15.8556C5.14792 15.1259 3.94368 13.9249 3.20996 12.4396",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 1.25L13.0998 10.16C12.9124 10.3463 12.659 10.4508 12.3948 10.4508C12.1306 10.4508 11.8772 10.3463 11.6898 10.16L9.2998 7.76C9.11244 7.57375 8.85899 7.46921 8.5948 7.46921C8.33062 7.46921 8.07717 7.57375 7.8898 7.76L0.549805 15.1",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_6829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchVolume);
export default __webpack_public_path__ + "static/media/search-volume.3aed935cb33d6de0fd01fd1ca5ee6b02.svg";
export { ForwardRef as ReactComponent };